__turbopack_context__.v({
  "Experts": "Experts-module-scss-module__vdKIKa__Experts",
  "arrow": "Experts-module-scss-module__vdKIKa__arrow",
  "arrow_cont": "Experts-module-scss-module__vdKIKa__arrow_cont",
  "callback": "Experts-module-scss-module__vdKIKa__callback",
  "callback__data": "Experts-module-scss-module__vdKIKa__callback__data",
  "callback__title": "Experts-module-scss-module__vdKIKa__callback__title",
  "callback_cont": "Experts-module-scss-module__vdKIKa__callback_cont",
  "circle": "Experts-module-scss-module__vdKIKa__circle",
  "expertInfo": "Experts-module-scss-module__vdKIKa__expertInfo",
  "fadeInUp": "Experts-module-scss-module__vdKIKa__fadeInUp",
  "info": "Experts-module-scss-module__vdKIKa__info",
  "slide": "Experts-module-scss-module__vdKIKa__slide",
  "slider": "Experts-module-scss-module__vdKIKa__slider",
  "slider_container": "Experts-module-scss-module__vdKIKa__slider_container",
  "smallcircle": "Experts-module-scss-module__vdKIKa__smallcircle",
  "specalist": "Experts-module-scss-module__vdKIKa__specalist",
});
